export default __webpack_public_path__ + "static/media/T34.e231aec3.JPG";